'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocalRestaurant = function MdLocalRestaurant(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24.8 19.2l-2.5 2.4 11.5 11.5-2.3 2.4-11.5-11.5-11.5 11.5-2.3-2.4 16.2-16.2q-0.9-1.9-0.3-4.4t2.7-4.5q2.4-2.4 5.4-2.7t4.7 1.4 1.5 4.8-2.8 5.5q-2 1.9-4.5 2.5t-4.3-0.3z m-11.3 3.1l-7-7.1q-2-1.9-2-4.7t2-4.6l11.7 11.6z' })
        )
    );
};

exports.default = MdLocalRestaurant;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/local-restaurant.js
// module id = 3518
// module chunks = 168707334958949